import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const filtersListSuccess = (
  payload = {},
  type = types.FILTERS_LIST_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const filtersListLoading = (
  payload = {},
  type = types.FILTERS_LIST_LOADING
) => {
  return {
    type,
    payload
  };
};
